import { Component, Input, viewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  NgbAccordionBody,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
  NgbAccordionToggle,
  NgbTooltip
} from '@ng-bootstrap/ng-bootstrap';
import { INavMenuItem } from '../nav-menu-item.interface';

@Component({
  selector: 'app-nav-menu-link',
  standalone: true,
  imports: [
    RouterLink,
    NgbTooltip,
    RouterLinkActive,
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionToggle,
    NgbAccordionCollapse,
    NgbAccordionBody
  ],
  templateUrl: './nav-menu-link.component.html',
  styleUrl: './nav-menu-link.component.scss',
})
export class NavMenuLinkComponent {
  accordionToggle = viewChild(NgbAccordionDirective);

  @Input() navMenuitemData!: INavMenuItem;
  @Input() collapsedMenu!: boolean;
  @Input() isTopLevelElement = false;

  @Input() set expanded(value: boolean) {
    if (value) this.accordionToggle()?.expandAll();
  }

  isActive = false;
}
